module.exports = __webpack_public_path__ + "static/media/kaisa.514bf45e.png";